import { render, staticRenderFns } from "./BigCard.vue?vue&type=template&id=0d9037ee&scoped=true"
import script from "./BigCard.vue?vue&type=script&lang=ts"
export * from "./BigCard.vue?vue&type=script&lang=ts"
import style0 from "./BigCard.vue?vue&type=style&index=0&id=0d9037ee&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9037ee",
  null
  
)

export default component.exports